import { render, staticRenderFns } from "./AuthSidebar.vue?vue&type=template&id=347885b4&scoped=true&"
import script from "./AuthSidebar.vue?vue&type=script&lang=js&"
export * from "./AuthSidebar.vue?vue&type=script&lang=js&"
import style0 from "./AuthSidebar.vue?vue&type=style&index=0&id=347885b4&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "347885b4",
  null
  
)

export default component.exports